// class on body determines if we show "support us" banners
if (isPremium) {document.body.classList.add('isp')}